import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Step, Stepper, Tab, Table, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingPrintPostSlideout extends Layout {
    buttonIsBusy: Button;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacerPrint: HorizontalSpacer;
    labelAmountPrinted: Label;
    labelAmountPrintedValue: Label;
    labelCaAmount: Label;
    labelCountCa: Label;
    labelCountCaConfirm: Label;
    labelCountMx: Label;
    labelCountMxConfirm: Label;
    labelCountUs: Label;
    labelCountUsConfirm: Label;
    labelInvoiceAmountMx: Label;
    labelInvoiceAmountMxConfirm: Label;
    labelInvoiceAmountUs: Label;
    labelInvoiceAmountUsConfirm: Label;
    labelInvoiceCaAmountConfirm: Label;
    labelInvoicePostExceptions: Label;
    labelInvoiceTotal: Label;
    labelInvoiceTotalAmount: Label;
    labelLoadingImages: Label;
    labelPostReview: Label;
    labelPostReviewAmountPrinted: Label;
    labelPostReviewAmountPrintedValue: Label;
    labelPostReviewInvoiceTotal: Label;
    labelPostReviewInvoiceTotalAmount: Label;
    labelPrintPreview: Label;
    layoutGLPost: Layout;
    layoutGLReport: Layout;
    layoutGLTransferEditReport: Layout;
    layoutPost: Layout;
    layoutPostAgentReport: Layout;
    layoutPostDatafusionReport: Layout;
    layoutPrintPreview: Layout;
    layoutTransferEditExceptions: Layout;
    layoutTransferEditReport: Layout;
    layoutTransferExceptions: Layout;
    layoutTransferReport: Layout;
    panelCa: Panel;
    panelCaConfirm: Panel;
    panelGLReport: Panel;
    panelGLTransferEditReport: Panel;
    panelMx: Panel;
    panelMxConfirm: Panel;
    panelPostAgentReport: Panel;
    panelPostConfirm: Panel;
    panelPostDatafusionReport: Panel;
    panelPostEdit: Panel;
    panelPostExceptions: Panel;
    panelPostGL: Panel;
    panelPostInvoices: Panel;
    panelPrintPreview: Panel;
    panelSpinner: Panel;
    panelTransferEditExceptions: Panel;
    panelTransferExceptions: Panel;
    panelTransferReport: Panel;
    panelTransferReportEdit: Panel;
    panelTransferToSettlement: Panel;
    panelTransferToSettlementEdit: Panel;
    panelUs: Panel;
    panelUsConfirm: Panel;
    sourceInvoicePost: DataSource;
    sourceInvoicePrint: DataSource;
    sourceInvoiceProcessing: DataSource;
    sourceTransferToSettlements: DataSource;
    stepEditList: Step;
    stepPostConfirmation: Step;
    stepPosting: Step;
    stepPrintReview: Step;
    stepTransferToSettlement: Step;
    stepTransferToSettlementEdit: Step;
    stepper2: Stepper;
    tabGL: Tab;
    tabGLPost: Tab;
    tabGLTransferEdit: Tab;
    tabPost: Tab;
    tabPostDataFusion: Tab;
    tabPostExceptions: Tab;
    tabPostSettlement: Tab;
    tabTransferEditExceptions: Tab;
    tabTransferExceptions: Tab;
    tabTransferReport: Tab;
    tabTransferReportEdit: Tab;
    tableInvoicePostException: Table;
    tabsetPostInvoices: Tabset;
    tabsetTransferReports: Tabset;
    tabsetTransferReportsEdit: Tabset;
}
